module.exports = __webpack_public_path__ + "static/media/valor2.3ffc2d30.png";